import { AppBar } from "@components/AppBar/AppBar";
import { AppBarMinimal } from "@components/AppBar/AppBarMinimal";
import { Footer, FooterMinimal } from "@components/Footer";
import { ApplicationState } from "@redux/reducers";
import { bp, transition } from "@styles/theme";
import { Path } from "@utils/Path";
import { useRouter } from "next/router";
import { PropsWithChildren } from "react";
import { useSelector } from "react-redux";
import styled, { css } from "styled-components";

export const linkStyles = css`
    font-weight: 600;
    text-decoration: underline;
    transition: color ${transition.hoverIn};

    &:hover {
        color: ${props => props.theme.color.red};
    }
`;

export const TextButton = styled.button`
    ${linkStyles}
`;

export const underlineLeft = css`
    &::after {
        content: "";
        display: block;
        width: 70px;
        height: 4px;
        background-color: ${props => props.theme.color.red};
        margin-top: 10px;

        ${bp.large} {
            width: 100px;
            height: 5px;
            margin-top: 15px;
        }
    }
`;

export const underlineCenter = css`
    ${underlineLeft}
    &:after {
        margin-left: auto;
        margin-right: auto;
    }
`;

export const UserDataList = styled.div`
    span {
        display: block;
        font-size: 18px;
        margin-bottom: 8px;
    }
`;

export const Main = styled.main`
    flex: 1 0 auto;
`;

export const Layout = ({ children }: PropsWithChildren<{}>) => {
    const router = useRouter();
    const pagesWithBasicAppbar = [
        Path.cartCheckoutData,
        Path.cartPaymentMethods,
        Path.cartCheckoutSubmit,
        Path.serviceCheckoutData,
        Path.servicePaymentMethods,
        Path.serviceCheckoutSubmit,
    ];

    const pagesWithoutFooterNewsletter = () => {
        if (router.asPath.includes(Path.cartOrderConfirmation)) {
            return true;
        }

        if (router.asPath.includes(Path.serviceOrderConfirmation)) {
            return true;
        }

        if (router.asPath.includes(Path.newsletter)) {
            return true;
        }

        return false;
    };

    const isBasicAppbarRoute = pagesWithBasicAppbar.includes(router.asPath);
    const menuItems = useSelector((state: ApplicationState) => state.appData.menuItems);

    return isBasicAppbarRoute ? (
        <>
            <AppBarMinimal />
            <div className="_ce_measure_top">{children}</div>
            <FooterMinimal />
        </>
    ) : (
        <>
            <div id="cts-top" />
            <div className="_ce_measure_top">
                <AppBar menuItems={menuItems} />
                <main>{children}</main>
            </div>
            <div id="cts-bottom" />
            <Footer hideNewsletter={pagesWithoutFooterNewsletter()} />
        </>
    );
};
